import { Component, OnInit } from '@angular/core';
import { MENU_ITEMS } from '../pages-menu';
import { Page } from './PageRoles/Model/pageRoles';
import { UserPermissionService, ComponentPermissionService } from '../../@core/auth/services';
import { NbMenuItem } from '@nebular/theme';
@Component({
  selector: 'ngx-administration',
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="this.PageModel"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class AdministrationComponent implements OnInit {

  PageModel: NbMenuItem[] = [] as NbMenuItem[]
  constructor(
    private userPermissionService: UserPermissionService,
    private componentPermissionService: ComponentPermissionService
  ) {


  }
  ngOnInit(): void {
    
    this.userPermissionService.userPages$.subscribe((data) => {
      if (data && data.length > 0) {
        this.PageModel = this.mapPageVmToMenuItem(data);
        console.log('Using cached user pages:', data);
        
        this.componentPermissionService.checkCurrentPageAccess();
      }
    });

    if (!this.userPermissionService.arePagesLoaded() && !this.userPermissionService.isCurrentlyLoading()) {
      this.userPermissionService.loadUserPages().subscribe();
    }
  }
  mapPageVmToMenuItem(pages: Page[]): NbMenuItem[] {
    const pages_ = [];
    pages.forEach((item) => {
      if (item.children.length > 0) {
        pages_.push({
          title: item.title,
          icon: item.icon,
          link: item.link,
          expanded: true,
          children: item.children && item.children.length > 0
            ? this.mapPageVmToMenuItem(item.children)
            : []
        })
      }else if (item.id === 1) 
        {
          pages_.push({
            title: item.title,
            icon: item.icon,
            link: item.link,
            pathMatch: 'full'
          })
        }
      else {
        pages_.push({
          title: item.title,
          icon: item.icon,
          link: item.link
        })
      }
    })
    return pages_;

  }


  menu = MENU_ITEMS;
}
